import Clayton from "static/images/AuthTestimonial/Clayton.png";
import FernandoBraun from "static/images/AuthTestimonial/FernandoBraun.png";
import NB from "static/images/AuthTestimonial/NB.png";
import RyanBrother from "static/images/AuthTestimonial/RyanBrother.png";

export type TestimonialCardType = {
  id: number;
  quote: string;
  name: string;
  title: string;
  image: string;
};

export const testimonials: TestimonialCardType[] = [
  {
    id: 1,
    quote:
      "Inkle went above and beyond, offering prompt assistance. Highly recommended for all startups looking for cost-effective solution with exceptional customer support.",
    name: "Ryan Wenger",
    title: "Co-Founder at Inhouse",
    image: RyanBrother,
  },
  {
    id: 2,
    quote:
      "Nothing comes close to what Inkle offers for US Taxes and Compliance. Their product has a simple and easy-to-use UI with streamlined processes.",
    name: "Nikolay Bonev",
    title: "Co-Founder & CTO at Shelf",
    image: NB,
  },
  {
    id: 3,
    quote:
      "Inkle is a must-have for founders with US entities. They offer amazing customer service and results at a very affordable price.",
    name: "Fernando Braun",
    title: "Co-Founder & CEO at 2250",
    image: FernandoBraun,
  },
  {
    id: 4,
    quote:
      "Incredible software & an extremely detail-oriented team. Must have for founders wanting to save time without sacrificing quality.",
    name: "Clayton Jacobs",
    title: "Founder & CEO at CreatorDB",
    image: Clayton,
  },
];
